import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledTextAreaDiv = styled.div`
  ${rtl`
    &.m-text-area {
      position: relative;
      box-sizing: border-box;

      textarea {
        width: 100%;
        padding: 0.75rem 0 0.75rem 1rem;
        border-width: 0.0625rem;
        border-style: solid;
        background-color: transparent;

        &:focus {
          border-color: var(--t-brand-fg-color);
          box-shadow: 0 0 0 0.03125rem inset;
        }
      }

      label {
        position: absolute;
        top: -0.47rem;
        left: 0.6875rem;
        font-size: 0.875rem;
        text-transform: capitalize;
        background: ${theme.color['base-20']};
        padding: 0 0.375rem;
        font-weight: 500;
        letter-spacing: 0;
        color: ${theme.color['dark-gray-13']};
        margin-bottom: 0;
      }

      &.is-error textarea {
        border-color: var(--t-form-error-color) !important;
    }
      &.is-error {
        .error-text {
          color: var(--t-form-error-color);
      }
`}
`;
